"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--uy2137"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: ", "\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: ", "\n"])), function (props) {
  return props.width;
});
exports.Wrapper = Wrapper;
var templateObject_1;